/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/latest.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'An alias for `LAST` where\nthe sort field (the second parameter) is implicit and is set to `@timestamp`.',
  examples: [
    '        @timestamp        |  name   | number\n"2025-11-25T00:00:00.000Z | alpha   | 1"\n"2025-11-25T00:00:01.000Z | alpha   | 2"\n"2025-11-25T00:00:02.000Z | bravo   | null"\n"2025-11-25T00:00:03.000Z | alpha   | 4"\n"2025-11-25T00:00:04.000Z | bravo   | 5"\n"2025-11-25T00:00:05.000Z | charlie | [6, 7, 8]"\n"2025-11-25T00:00:06.000Z | delta   | null"\n\nFrom dataset\n| STATS last_val = LATEST(number) BY name',
  ],
  params: {
    field: 'The search field',
  },
};

export default docs;
